const EXPECTED_COLOR = '#f48368'; // 'purple';
const ACTUAL_COLOR = '#676490'; // 'blue';

export const STYLE_LINE_EXPECTED = {
  data: {
    stroke: EXPECTED_COLOR,
    strokeWidth: 2,
  },
};

export const STYLE_LINE_ACTUAL = {
  data: {
    stroke: ACTUAL_COLOR,
    strokeWidth: 2,
  },
};

export const STYLE_TITLE = {
  fill: '#000000',
  fontFamily: 'inherit',
  fontSize: '18px',
  fontWeight: 'bold',
};

export const STYLE_AXIS_TIME = {
  axis: {
    stroke: 'black',
    strokeWidth: 1,
  },
  ticks: {
    size: 5,
    stroke: 'black',
    strokeWidth: 1,
  },
  tickLabels: {
    fill: 'black',
    fontFamily: 'inherit',
    fontSize: 8,
  },
  grid: {
    stroke: '#333',
    strokeWidth: 1,
    strokeDasharray: '2, 4',
  },
};

export const STYLE_AXIS_TASKS = {
  axis: {
    stroke: 'black',
    strokeWidth: 1,
  },
  ticks: {
    stroke: 'black',
    size: 5,
    strokeWidth: 1,
  },
  tickLabels: {
    fill: 'black',
    fontFamily: 'inherit',
    textAnchor: 'end',
    fontSize: 8,
  },
  grid: {
    stroke: '#333',
    strokeWidth: 1,
    strokeDasharray: '2, 4',
  },
};



// WEBPACK FOOTER //
// ./src/views/Project/PPCGraph/StyleObjects.js